import * as z$1 from "zod/v4";
//#region src/schemas/space-mesh/dispatch-space-history.ts
const dispatchSpaceHistoryRequestSchema = z$1.strictObject({});
const dispatchSpaceHistoryResultSchema = z$1.strictObject({
	spaceId: z$1.string().min(1),
	sourceSignalId: z$1.string().min(1),
	beforeCount: z$1.literal(20),
	afterCount: z$1.literal(0),
	signals: z$1.array(z$1.record(z$1.string(), z$1.unknown())).max(21),
	nextCursor: z$1.string().min(1).nullable()
});
//#endregion
export { dispatchSpaceHistoryRequestSchema, dispatchSpaceHistoryResultSchema };

//# sourceMappingURL=dispatch-space-history.js.map